import React from "react";
import { useTrafficSourceFilters } from "../logic/trafficSourcesFilters.logic";
import { useFetchTrafficSources } from "../logic/fetchTrafficSource.logic";
import { useTrafficSourceTableLogic } from "../logic/trafficSourceTable.logic";
// import TrafficSourceTableTabMenu from "./TrafficSourceTableTabMenu";
import Table from "../../../components/Table/Table";
import TrafficSourceTableFilter from "./TrafficSourceTableFilter";
import ConfirmBox from "../../../components/ConfirmBox/ConfirmBox";

const TrafficSourceTable = ({ openEditForm }) => {
  const filterValuesLogic = useTrafficSourceFilters();

  const {
    clearAllSelection,
    filterValues,
    // selectionAddActions,
    filtersClearToggle
  } = filterValuesLogic;

  const {
    loadingTrafficSources,
    trafficSources,
    page,
    setPage,
    size,
    setSize,
    orderBy,
    setOrderBy,
    orderDirection,
    setOrderDirection,
    total,
    getTrafficSources
  } = useFetchTrafficSources({
    filterValues,
    filtersClearToggle
  });

  // const { setArchivedData } = selectionAddActions;

  const {
    headers,
    actions,
    archiveModalOpen,
    deleteModalOpen,
    restoreModalOpen,
    handleModalClose,
    archiveTrafficSource,
    deleteTrafficSource,
    restoreTrafficSource
  } = useTrafficSourceTableLogic({
    filterValues,
    getTrafficSources,
    openEditForm
  });

  return (
    <div className="flow-content">
      {/* Removing archived section for now */}
      {/* <TrafficSourceTableTabMenu
        archivedData={filterValues.archivedData}
        setArchivedData={setArchivedData}
      /> */}

      <TrafficSourceTableFilter
        handleSearch={getTrafficSources}
        clearAllSelection={clearAllSelection}
        filterValuesLogic={filterValuesLogic}
        loadingTrafficSources={loadingTrafficSources}
      />
      <div>
        {trafficSources && (
          <Table
            headers={headers}
            rowValues={trafficSources}
            actions={actions}
            isLoading={loadingTrafficSources.isLoading}
            noIds={true}
            noCheckboxes={true}
            page={page}
            setPage={setPage}
            size={size}
            setSize={setSize}
            total={total}
            rowsPerPageOptions={[10, 20, 30, 50, 100, 200]}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            orderDirection={orderDirection}
            setOrderDirection={setOrderDirection}
            tableType="TrafficSources"
          />
        )}
      </div>
      {archiveModalOpen && (
        <ConfirmBox
          title="Archive Traffic Type"
          message="Are you sure you want to archive this link type?"
          confirmAction={archiveTrafficSource}
          denyAction={handleModalClose}
        />
      )}
      {deleteModalOpen && (
        <ConfirmBox
          title="Delete Traffic Type"
          message="Are you sure you want to delete this link type?"
          confirmAction={deleteTrafficSource}
          denyAction={handleModalClose}
        />
      )}
      {restoreModalOpen && (
        <ConfirmBox
          title="Restore Traffic Type"
          message="Are you sure you want to restore this link Type?"
          confirmAction={restoreTrafficSource}
          denyAction={handleModalClose}
        />
      )}
    </div>
  );
};

export default TrafficSourceTable;
